(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const qtyButtons = document.querySelectorAll('.ts-qty-btn');

    qtyButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const input = this.parentElement.querySelector('.ts-qty-input');
        const currentValue = parseInt(input.value);
        const action = this.dataset.action;

        if (action === 'increase') {
          input.value = currentValue + 1;
        } else if (action === 'decrease' && currentValue > 0) {
          input.value = currentValue - 1;
        }

        // Show update button if it was hidden
        const updateBtn = document.querySelector('.ts-update-btn');
        if (updateBtn) {
          updateBtn.style.opacity = '1';
          updateBtn.style.pointerEvents = 'all';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Section specific JS moved to assets/collection-ajax.js */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    initProductTabs();
  });

  // Re-init for theme editor
  window.addEventListener('shopify:section:load', function() {
    initProductTabs();
  });

  function initProductTabs() {
    const tabs = document.querySelectorAll('.ts-pxt-tab-btn');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const wrap = this.closest('.ts-pxt-tabs-wrap');
        const targetId = this.dataset.tabTarget;
        
        // Remove active state from all tabs in this wrap
        wrap.querySelectorAll('.ts-pxt-tab-btn').forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        
        // Hide all panels in this wrap
        wrap.querySelectorAll('.ts-pxt-panel').forEach(p => {
          p.classList.remove('is-active');
          p.setAttribute('hidden', '');
        });
        
        // Activate current tab
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');
        
        // Show current panel
        const panel = wrap.querySelector(`#ts-pxt-panel-${targetId}-${wrap.closest('.ts-pxt-section').id.replace('ts-pxt-', '')}`) || wrap.querySelector(`#ts-pxt-panel-${targetId}`);
        if (panel) {
          panel.classList.add('is-active');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
